import { defineStore } from 'pinia';
import { AdditionalQuestion } from '@/types/guest';
import { AdditionalQuestionsState } from './additionalQuestionsState';

export const useAdditionalQuestionsStore = defineStore('additionalQuestions', {
  state: (): AdditionalQuestionsState => {
    return {
      questionTemplates: [],
    };
  },
  getters: {
    getQuestionTemplates(state): AdditionalQuestion[] {
      return state.questionTemplates;
    },
  },
  actions: {
    addQuestionTemplate(question: AdditionalQuestion) {
      this.questionTemplates.push(question);
    },
    removeQuestionTemplate(questionId: string) {
      this.questionTemplates = this.questionTemplates.filter((q) => q.id !== questionId);
    },
    updateQuestionTemplate(question: AdditionalQuestion) {
      const index = this.questionTemplates.findIndex((q) => q.id === question.id);
      if (index !== -1) {
        this.questionTemplates[index] = question;
      }
    },
    setQuestionTemplates(questions: AdditionalQuestion[]) {
      this.questionTemplates = questions;
    },
  },
});
